module.exports = __webpack_public_path__ + "static/img/arthroscopy-17.9563cab.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/productspic/arthroscopypic/arthroscopy-17.jpg
// module id = GGu7
// module chunks = 51